// extracted by mini-css-extract-plugin
module.exports = {"button-remove-property":"CompetitivePropertySelector_button-remove-property__ds5A_"};